 {
    "common": {
    "thisWeek": "Esta semana",
    "lastWeek": "La semana pasada",
    "lastNumberOfDays": "Últimos {numberOfDays} días",
    "thisMonth": "Este mes"
    },
    "subAccounts": "Subcuentas",
    "submitFeedback": "Enviar comentarios",
    "createSubAccount": "Crear subcuenta",
    "viewScheduleReports": "Ver informes programados",
    "searchSubAccount": "Buscar por subcuenta",
    "columns": "Columnas",
    "sortBy": "Ordenar por",
    "selectColumns": "Seleccionar columnas",
    "maxColumns": "Máx. 8 columnas a la vez",
    "applyColumns": "Aplicar columnas",
    "activeUsers": "Usuarios activos",
    "appointments": "Citas",
    "contacts": "Contactos",
    "emails": "Gmail",
    "textMessages": "Cuerpo de los mensajes",
    "calls": "Llamadas",
    "submissions": "Envíos",
    "reviews": "Reseñas",
    "sitesCreated": "Sitios creados",
    "name": "Nombre",
    "formSubmissions": "Envíos de formularios",
    "surveySubmissions": "Envíos de encuestas",
    "facebookFormSubmissions": "Envíos de formularios de Facebook",
    "funnels": "Embudos",
    "websites": "Sitios web",
    "forms": "Formularios",
    "surveys": "Encuestas",
    "highestFirst": "Máx. primero",
    "lowestFirst": "Primero el más bajo",
    "orderBy": "Ordenar Vía",
    "noMoreLocations": "No más Dirección encontrada",
    "preparingReport": "Estamos preparando su informe…",
    "preparingReportDesc": "No cierre ni vuelva a cargar esta ventana mientras la exportación está en curso",
    "outOf": "De",
    "subAccountsExported": "Subcuentas exportadas",
    "close": "Cerrar",
    "scheduledForDeletion": "Programado para eliminación",
    "readyToSell": "Listo para vender",
    "closedWon": "Cerrado (Ganado)",
    "wpSaleSuccessful": "La venta de WordPress se ha llevado a cabo con éxito",
    "wpNotSold": "WordPress aún no se ha vendido",
    "yxtSaleSuccessful": "La venta de Yext se ha llevado a cabo correctamente",
    "yxtNotSold": "Ytexto que aún no se ha vendido",
    "saasSubInactive": "La suscripción SaaS está inactiva",
    "saasSubTrialing": "SaaS Suscripción en prueba",
    "saasSubActive": "SaaS Suscripción es Dinámico",
    "emailRebillingActive": "Correo electrónico Refacturación es Dinámico",
    "emailRebillingInactive": "El correo electrónico Refacturación está inactivo",
    "twilioRebillingActive": "Twilio Refacturación es Dinámico",
    "twilioRebillingInactive": "Twilio Refacturación está inactivo",
    "wpRebillingActive": "La Refacturación por WhatsApp está activa",
    "wpRebillingInactive": "La Refacturación por WhatsApp está inactiva",
    "saasModeActivated": "El modo SaaS está habilitado",
    "paymentPending": "El Pago está pendiente",
    "saasModeNotActivated": "El modo SaaS no está habilitado",
    "managedByLCPhone": "Gestionar Vía LC Teléfono",
    "migrationToLCPhone": "En proceso de migración a LC Teléfono",
    "notManagedByLCPhone": "Not Gestionar Vía LC Teléfono",
    "managedByLCEmail": "Gestionar a través LeadConnector Email System",
    "notMangedByLCEmail": "No gestionada a través LeadConnector Email System",
    "remainingWalletBalance": "Saldo restante del monedero de esta ubicación SaaS",
    "reports": "Informes",
    "switchToSubAccount": "Cambiar a subcuenta",
    "manageClient": "Gestionar cliente",
    "subAccountDeletedIfChangedMind": "Esta subcuenta se eliminará el {time}, si ha cambiado de opinión -",
    "subAccountDeletedInMinute": "Esta subcuenta se eliminará en el próximo minuto",
    "changedMind": "Si Tú've Dinámico tu mente",
    "clickHere": "hacer clic aquí",
    "subAccountPaused": "Esta subcuenta está en pausa. Tus clientes no pueden iniciar sesión, pero la agencia sí. Para reactivar esta cuenta",
    "subAccountRestricted": "Esta subcuenta está en pausa porque está pendiente de aprobación.",
    "subAccountVerificationPending": "Esta subcuenta está en pausa debido a la verificación pendiente del correo electrónico y el teléfono por parte del administrador de la subcuenta.",
    "subAccountDeclined": "Esta subcuenta está pausada debido a que se ha rechazado la solicitud de aprobación. Aún puede reactivar esta subcuenta ",
    "here": "aquí.",
    "reviewAndResume": "para revisar y reactivar esta subcuenta.",
    "incomingCalls": "Llamadas entrantes",
    "outgoingCalls": "Llamadas salientes",
    "totalTalktime": "Tiempo Total en conversación",
    "incomingEmails": "Gmailentrante",
    "outgoingEmails": "Gmailsaliente",
    "incomingSms": "Mensajes de Cuerpo entrantes",
    "outgoingSms": "Mensajes de cuerpo salientes",
    "contactsCreated": "Total de contactos creados",
    "appointmentsBooked": "Total de citas reservadas",
    "totalFormSubmissions": "Total de envíos de formularios",
    "totalSurveySubmissions": "Total de envíos de Encuesta",
    "totalFacebookFormSubmissions": "Total de envíos de Formulario de Facebook",
    "incomingGMBMessages": "Mensajes entrantes de GBP",
    "outgoingGMBMessages": "Mensajes salientes de GBP",
    "gmbMessages": "Mensajes de GBP",
    "fbMessages": "Mensaje de Facebook",
    "incomingFbMessages": "Mensajes entrantes de Facebook",
    "outgoingFbMessages": "Mensajes salientes de Facebook",
    "igMessages": "Mensajes de Instagram",
    "incomingIgMessages": "Mensajes entrantes de Instagram",
    "outgoingIgMessages": "Mensajes salientes de Instagram",
    "totalReviews": "Total de reseñas",
    "positiveReviews": "Reseñas positivas",
    "negativeReviews": "Reseñas negativas",
    "back": "Atrás",
    "selectDashboards": "Seleccionar tableros",
    "next": "Siguiente",
    "backToSubAccounts": "Volver a subcuentas",
    "pauseSchedule": "Pausar la programación",
    "resumeSchedule": "programación de la Reanudar",
    "editSchedule": "Editar programación",
    "addSchedule": "Añadir programación",
    "selectReportToAdd": "Seleccionar los informes para incluir in el correo electrónico",
    "selectAll": "Seleccionar cada",
    "pauseScheduleConfirm": "¿Estás seguro de que quieres pausar el informe de programación?",
    "resumeScheduleConfirm": "¿Estás seguro de que quieres reanudar el informe programación?",
    "tasks": "Tareas",
    "conversations": "Conversaciones",
    "users": "Usuario",
    "dealOverview": "Visión general del Trato",
    "confirmAction": "Confirmar acción",
    "yes": "Sí",
    "no": "No",
    "reportDetails": "Detalles del informe",
    "reportCreatedOn": "Reportar Creada Activado",
    "searchByEmail": "Buscar Vía Correo electrónico",
    "lastActivity": "Última actividad",
    "noRecords": "No se han encontrado registros",
    "scheduleReport": "Programar informe",
    "schedule": "programación",
    "save": "Guardar",
    "emailSubject": "Línea de asunto",
    "frequency": "Frecuencia",
    "daily": "Diario",
    "weekly": "Semanal",
    "monthly": "Mensual",
    "nextScheduleDate": "Siguiente programación fecha",
    "startingOn": "Iniciando Activado",
    "timeOfDay": "Fecha de día",
    "reportsToTimezone": "El informe se enviará en la zona horaria de la subcuenta",
    "selectRecipients": "Seleccionar los destinatarios",
    "invalidEmail": "Introduzca una dirección de correo electrónico válida.",
    "testEmail": "Correo electrónico de Prueba",
    "selectTestRecipients": "Seleccionar los destinatarios de la Prueba",
    "setupSubject": "Configura el Asunto de arriba para probar el informe",
    "sendTest": "Subir Prueba",
    "scheduleSimilarSchedules": "Programar informe similar para otras subcuentas",
    "accountSummary": "Resumen de cuenta",
    "scheduleList": "Lista de programación",
    "subAccountName": "Nombre de la subcuenta",
    "nextRunDate": "Próxima fecha de ejecución",
    "reportSectionsAdded": "Secciones del informe añadidas",
    "status": "Estado",
    "scheduleAction": "Programar acción",
    "cancel": "Cancelar",
    "pleaseWait": "Cargando…",
    "confirm": "Confirmar",
    "booked": "Reservado",
    "confirmed": "Confirmada",
    "showed": "Asistido",
    "noShow": "No asistido",
    "cancelled": "Cancelado",
    "unread": "No leído",
    "engagement": "Compromiso",
    "reaction": "Reacción",
    "deliverySummary": "Resumen de la entrega",
    "successfulDelivery": "Entrega satisfactoria",
    "opened": "Abierto",
    "clicked": "Clicado",
    "replied": "Respondidas",
    "unsubscribed": "Suscripción cancelada",
    "complained": "Reclamado/denunciado",
    "failed": "Error",
    "bounced": "Rebotado",
    "open": "Abrir",
    "won": "Ganado",
    "abandoned": "Abandonado",
    "lost": "Perdido",
    "sent": "Enviado",
    "eject": "Expulsar",
    "delivered": "Enviado",
    "faceBookLeadForm": "Formulario de clientes potenciales de Facebook",
    "overdue": "Atrasado",
    "reviewsReceived": "Reseñas Recibido",
    "formBuilders": "Creadores de formularios",
    "switchToSaaS": "Cambiar a SaaS",
    "numberOfContacts": "Total de contactos",
    "numberOfAppointments": "Total de citas",
    "outreach": "Divulgación",
    "notSubAccountUser": "No es un usuario de subcuenta",
    "searchSubAccName": "Buscar por el nombre de la subcuenta",
    "recipients": "Destinatarios",
    "scheduleCreated": "Se ha creado una programación de informe por correo electrónico para ",
    "scheduleUpdated": "Se ha actualizado la programación del informe por correo electrónico para ",
    "scheduleNotCreated": "No se ha podido crear la programación del informe por correo electrónico para",
    "scheduleNotUpdated": "No se ha podido actualizar la programación del informe por correo electrónico para",
    "total": "Total",
    "inbound": "Entrante",
    "outbound": "Saliente",
    "totalEmails": "Total de correos electrónicos",
    "inboundEmails": "Correos electrónicos entrantes",
    "outboundEmails": "Correos electrónicos salientes",
    "totalTextMessages": "Total de mensajes de texto",
    "inboundTextMessages": "Mensajes de texto entrantes",
    "outboundTextMessages": "Mensajes de texto salientes",
    "totalCalls": "Total de llamadas",
    "inboundCalls": "Llamadas entrantes",
    "outboundCalls": "Llamadas salientes",
    "faceBookLeadFormSubmissions": "Envíos de formularios de contacto de Facebook",
    "inboundGMBMessages": "Mensajes entrantes de GBP",
    "outboundGMBMessages": "Mensajes salientes de GBP",
    "totalIgMessages": "Mensajes de Instagram totales",
    "inboundIgMessages": "Mensajes de Instagram entrantes",
    "outboundIgMessages": "Mensajes de Instagram salientes",
    "totalfbMessages": "Mensajes de Facebook totales",
    "inboundfbMessages": "Mensajes de Facebook entrantes",
    "outboundfbMessages": "Mensajes de Facebook salientes",
    "sitesCreatedFunnels": "Sitios creados - embudos",
    "sitesCreatedActiveFunnels": "Sitios creados - Embudos activos",
    "sitesCreatedWebsites": "Sitios creados - Sitios web",
    "sitesCreatedActiveWebsites": "Sitios creados - sitios web activos",
    "sitesCreatedForms": "Sitios creados - formularios",
    "sitesCreatedActiveForms": "Sitios creados - formularios activos",
    "sitesCreatedSurveys": "Sitios creados - Encuestas",
    "sitesCreatedActiveSurveys": "Sitios creados - Encuestas activas",
    "googleReviews": "Reseñas de Google",
    "facebookReviews": "Reseñas de Facebook",
    "inboundCallDuration": "Duración de la llamada entrante (horas)",
    "outboundCallDuration": "Duración de la llamada saliente (horas)",
    "pleaseSelect": "Seleccionar",
    "subAccountIsDeleted": "Esta subcuenta se ha eliminado",
    "subAccountIsPaused": "Esta subcuenta se ha pausado",
    "success": "Conseguido",
    "error": "Error",
    "testEmailSent": "Correo electrónico de Prueba enviado",
    "testEmailNotSent": "No se ha podido enviar la prueba de correo electrónico",
    "reviewRequest": "Solicitud de reseña",
    "pendingTransferDescription": "Otras agencias han solicitado transferirle subcuentas.",
    "pendingTransferHeading": "Tiene solicitudes de transferencia de subcuenta pendientes.",
    "subAccountTransfer": "Transferencias de subcuentas",
    "manageSubAccTransfer": "Gestione sus solicitudes de transferencia de subcuenta",
    "subAccRequest": "Solicitudes de la subcuenta {tabName}",
    "receive": "Heredar",
    "send": "Enviar",
    "release": "Publicar",
    "requests": "{count} solicitudes",
    "subAccLimit": "Límite de uso de subcuentas alcanzado.",
    "subAccPlanLimit": "Ha utilizado 3/3 subcuentas permitidas en su plan actual.",
    "upgradeTime": "¡Es hora de una actualización!",
    "upgradeHigher": "Actualice a un plan superior para aceptar la transferencia de la subcuenta.",
    "browse": "Examinar los planes",
    "pendingTransferTitle": "Ya hay una solicitud de transferencia pendiente para esta subcuenta.",
    "unableTransfer": "No se puede transferir la subcuenta a esta agencia.",
    "unableEjectCancel": "No se puede cancelar la solicitud de expulsión de la subcuenta.",
    "EjectErrorDetails": "La solicitud de expulsión de la subcuenta no puede ser cancelada.",
    "hippaErrorDescription": "Esta subcuenta está habilitada para HIPAA y no se puede transferir a una agencia que no sea HIPAA.",
    "pendingTransferErrorDescription": "Cancele la solicitud de transferencia existente para esta subcuenta antes de crear una nueva.",
    "receivingAgency": "Agencia destinataria",
    "releasingAgency": "Agencia de publicación",
    "noOfContacts": "Total de contactos",
    "requestedDate": "Fecha solicitada",
    "action": "Acción",
    "cancelTransfer": "Cancelar la transferencia",
    "decline": "Rechazar",
    "cancelTransferRequest": "¿Cancelar la solicitud de transferencia de la subcuenta?",
    "cancelEjectRequest": "¿Cancelar la solicitud de expulsión de la subcuenta?",
    "cancelRequestDescription": "La agencia receptora ya no verá esta solicitud de transferencia y la subcuenta {name} no se transferirá.",
    "cancelEjectRequestDescription": "El usuario seleccionado ya no podrá crear una nueva agencia desde la subcuenta {name}.",
    "declineRequest": "¿Rechazar la solicitud de transferencia de la subcuenta?",
    "declineRequestDescription": "La solicitud será rechazada y la subcuenta {name} no se transferirá a su agencia.",
    "approveTransfer": "¿Aprueba usted la transferencia de la subcuenta a su agencia?",
    "approveTransferDescription": "La subcuenta {name} se transferirá a su agencia.",
    "transferNow": "Transferir ahora",
    "cancelNow": "Cancelar ahora",
    "transferErrorDetails": "Esta subcuenta no puede ser transferida.",
    "cancelRequest": "Cancelar solicitud",
    "received": "Recibido",
    "approve": "Aprobar",
    "goBack": "Volver",
    "done": "Hecho",
    "subAccountTransferred": "¡La subcuenta se ha transferido correctamente!",
    "subAccountTransferDescription": "Aunque la subcuenta se ha transferido, algunos activos como los usuarios, los números de teléfono, las cuentas de Mailgun y los listados de Yext pueden tardar entre 10 y 15 minutos en reflejarse en el destino.",
    "activeSubscriptionsAlert": "La Ubicación tiene Dinámico Suscripción. Cancelar cada Suscripción antes de la Transferencia a ciegas la Ubicación. Lista de suscripción dinámica: {subscriptions}",
    "isSaasEnabled": "Habilitado para SaaS",
    "typeToSearch": "Escribir para buscar",
    "dateAdded": "Fecha de adición",
    "emailEngagement": "Interacción con el correo electrónico",
    "emailReaction": "Reacción de correo electrónico",
    "emailDeliverySummary": "Resumen de entregas de correo electrónico",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Resumen de la cuenta - {subAccountName}",
    "test": "Prueba",
    "scheduleExists": "La programación existe",
    "aToZ": "De la A a la Z",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Solo los usuarios administradores pueden añadir nuevas subcuentas.",
    "locationName": "Nombre de la ubicación",
    "transferCompleted": "La solicitud de transferencia para esta ubicación ya ha sido procesada. Actualice la página.",
    "unauthorizedTransfer": "Tú no estás autorizado para realizar esta acción. Solo los propietarios de la agencia pueden realizar esta acción.",
    "bulkLocationTransfer": "Transferencias en lote de subcuentas",
    "singleRequest": "Solicitud única",
    "bulkRequest": "Solicitud masiva",
    "backToLocationTransfer": "Regresar a la transferencia de ubicación",
    "initiateBulkTransfer": "Inicie la transferencia en lote de subcuentas",
    "initiateBulkTransferDescription": "Seleccione las subcuentas que desea transferir o introduzca sus ID separados por comas.",
    "subAccountId": "Id. de la subcuenta",
    "selectFromList": "Seleccione de la lista",
    "addManually": "Añadir manualmente",
    "accountsSelected": "Seleccionados: {count}",
    "selectAllSubAccounts": "Seleccionar cada",
    "removeAll": "Eliminar todo",
    "addManualLocations": "Añada los ID de ubicación separados por comas",
    "manualAllLocationIds": "Ubicación IDs de la subcuenta Tú deseas Transferir, Separado Vía comas.",
    "enterLocationIds": "Introduzca los ID de ubicación",
    "selectSubAccounts": "Seleccione las subcuentas y transfiéralas a una agencia existente",
    "subAccountTransferWarning": "Cada subcuenta activos y el Usuario obtendrán Transferencia a ciegas.",
    "proceed": "Proceder",
    "bulkRequestSubmitted": "Solicitud de transferencia en lote enviada",
    "bulkRequestSubmittedDescription": "Cada subcuenta será transferida una vez que la agencia receptora acepte la solicitud de transferencia. Puede hacer un seguimiento del estado de la solicitud en la página «{pagename}». (siempre que cumplan los requisitos)",
    "bulkTransferRequestFailed": "La solicitud de transferencia en lote ha fallado",
    "errorLocations": "Subcuentas con errores",
    "viewDetails": "Ver detalles",
    "somethingWrong": "Se ha producido un error. Vuelva a intentarlo.",
    "confirmBulkRequest": "¿Confirmar solicitud de transferencia en lote?",
    "bulkTransferAccounts": "¿Transferir en lote las subcuentas seleccionadas '{count}'?",
    "confirmDetails": "Confirme los detalles antes de transferir.",
    "transferConsent": "He leído y comprendido la guía anterior y consiento en todas las limitaciones.",
    "transferInfo": "La transferencia de la subcuenta está sujeta a que la agencia receptora la acepte en su cuenta.",
    "receivingRelNo": "Número de relación de la agencia receptora",
    "enterRelNo": "Introducir el número de relación",
    "transferConfirmation": "Al completar esta acción, las solicitudes de transferencia masiva/en bloque se enviarán a la agencia Recibido ({ relNo }). Cada subcuenta Tú've Seleccionado será Transferencia a ciegas una vez que la agencia recibida la acepte. Ten en cuenta que esta acción es irreversible para cada subcuenta incluida in el Transferir.",
    "confirmPassword": "Confirmar escribiendo password debajo",
    "enterPassword": "Introduzca la contraseña",
    "requestTransfer": "Solicitar transferencia",
    "confirmTransfer": "Confirme la transferencia",
    "notNow": "Ahora no",
    "invalidRelNo": "Número de relación no válido",
    "invalidPassword": "No hay password válida .",
    "searchSubAccounts": "Buscar subcuentas",
    "searchSubAccountsId": "Buscar ID de subcuenta",
    "takeAction": "Actúe",
    "sub_account_details": "Detalles de la subcuenta:",
    "no_of_contacts": "Total de contactos",
    "transfer_status": "Estado de la transferencia",
    "error_info": "Información de error",
    "bulk_transfer_status": "Estado de la transferencia en lote de subcuentas",
    "pending": "Pendiente",
    "processed": "Procesado",
    "reject_all": "Rechace todo",
    "accept_all": "Aceptar todo",
    "cancel_all": "Cancelar todo",
    "clearAll": "Borrar todo",
    "refresh": "Actualizar",
    "rejected": "Negado",
    "decline_transfer": "Rechazar transferir",
    "decline_bulk_transfer": "¿Rechazar la solicitud de transferencia en lote de la subcuenta?",
    "decline_bulk_transfer_description": "La solicitud será rechazada y las subcuentas {length} no se transferirán a su agencia.",
    "accept_bulk_transfer": "¿Aceptar la solicitud de transferencia en lote de subcuentas?",
    "accept_bulk_transfer_description": "La solicitud será aceptada y las {length} subcuentas se transferirán a su agencia.",
    "cancel_bulk_transfer": "¿Cancelar la transferencia en lote?",
    "cancel_bulk_transfer_description": "¿Está seguro de que desea cancelar esta transferencia en lote de {length} subcuentas a «{name}»?",
    "consent_sub_account_transfer": "Leer y dar su consentimiento a {link}",
    "sub_account_transfer_guidelines": "Directrices para la transferencia de subcuentas",
    "valid_rel": "Introduce un número de parentesco válido",
    "something_went_wrong": "Se ha producido un error. Vuelva a intentarlo.",
    "export": "Exportar",
    "export_success": "Los datos que Tú solicitas se están procesando. Tú enviarás a Heredar un Correo electrónico con los datos in alguna Fecha.",
    "export_failed": "No se han podido tratar los datos que tú has solicitado. Vuelve a intentarlo más tarde.",
    "selectAllError": "Solo puede seleccionar 1.000 subcuentas a la vez.",
    "max1000": "(Máximo 1.000)",
    "subAccountCount": "Recuento de subcuentas",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "¿Estás seguro de que quieres pausar {count} informes?",
    "scheduleBulkResumeConfirm": "¿Estás seguro de que quieres Reanudar {count} informes?",
    "resume": "Reanudar",
    "pause": "Pausar",
    "resumeSelected": "Reanudar Seleccionado",
    "pauseSelected": "Pausar seleccionado",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} informes seleccionados",
    "selectAllXReports": "Seleccione todos los informes {count}",
    "scheduleStatus": "Estado de la programación",
    "scheduleSearchPlaceholder": "Buscar usando correo electrónico o nombre de ubicación",
    "subAccountsPerPage": "Subcuentas por página",
    "previous": "Anterior",
    "scheduleBulkAction": "Programar acción en lote",
    "all": "Todo",
    "active": "Activo",
    "paused": "En pausa",
    "scheduleUpdatedSuccessfully": "la programación actualizada con éxito",
    "saveChanges": "Guardar los cambios",
    "pauseSchedulesTitle": "Informes de Pausar Activo Programado",
    "pauseSchedulesDescription": "hacer clic para pausar ahora Activo informa.",
    "pauseSchedulesAlert": "Esto solo afectará a las Cuentas que son ahora Dinámico.",
    "pauseAllSchedulesBtnText": "Pausa todos los informes programados",
    "autoScheduleTitle": "Programación automática para cuentas nuevas",
    "autoScheduleLabel": "Cree automáticamente informes programados cuando se añada una nueva subcuenta.",
    "autoScheduleAlert": "Deshabilitar esto si quieres configurar manualmente para la Nueva Cuenta.",
    "autoScheduleEnabledForNewAccounts": "Autoprogramación Habilitado para la Nueva Cuenta",
    "autoScheduleDisabledForNewAccounts": "Autoprogramación Deshabilitado para la Nueva Cuenta",
    "deleted": "Eliminado",
    "locationPaused": "Ubicación en pausa",
    "scheduleSettingsModalTitle": "informe de programación Configuración",
    "selectAllSchedules": "Seleccionar cada Programación",
    "selectScheduleForLocation": "Seleccionar la programación para {location}",
    "openSettings": "Abrir Configuración",
    "resumeScheduleForLocation": "Reanudar la programación de {location}",
    "pauseScheduleForLocation": "Pausar la programación para {location}",
    "actions": "Acciones",
    "deselectAll": "Deseleccionar cada",
    "scheduleBulkActionResumeSuccess": "Masivo/en bloque activación in progreso — En espera Deshabilitado Activado Nuevas Actividades",
    "scheduleBulkActionPauseSuccess": "Pausar informes — espere antes de tomar más acciones",
    "bulkActionCreationError": "Se está llevando a cabo otra acción en lote. Vuelva a intentarlo en un momento.",
    "bulkActionInProgress": "Masivo/en bloque Acción ya in progreso",
    "scheduledReports": "Informes Programado",
    "scheduleBulkActionCompleted": "Masivo/en bloque Acción Hecho con éxito",
    "pauseAllSchedulesModalTitle": "¿Pausar informes?",
    "pauseAllSchedulesModalText": "Esto pausará todos los informes programados activos en las subcuentas.",
    "addLocationIdsPlaceholder": "Añada los Id. de ubicación que desee transferir...",
    "helloWorld": {
      "count": "El recuento es {count}",
      "editIntro": "Editar",
      "editAction": "Para probar HMR",
      "checkOut": "Compruebe",
      "officialStarter": ", la versión inicial de Vue + Vite",
      "install": "Instalar",
      "installDescription": "En su IDE para una mejor experiencia de desarrollo",
      "learnMore": "Haga clic en los logotipos Vite y Vue para obtener más información"
    },
    "home": {
      "testMessage": "¡Hola! Esta es la página de inicio de prueba."
    },
    "reports": {
      "incoming": "Entrante",
      "outgoing": "Saliente",
      "duration": "Duración",
      "contactsCount": "Total de contactos",
      "appointmentsCount": "Total de citas",
      "formSubmissions": "Envíos de formularios",
      "surveySubmissions": "Envíos de encuestas",
      "facebookFormSubmissions": "Envíos de formularios de Facebook",
      "funnels": "Embudos",
      "websites": "Sitios web",
      "forms": "Formularios",
      "surveys": "Encuestas",
      "gbpMessages": "Mensajes GBP",
      "facebookMessages": "Mensajes de Facebook",
      "instagramMessages": "Mensajes de Instagram",
      "reviews": "Reseñas",
      "positives": "Positivas",
      "negatives": "Negativas"
    },
    "timeOptions": {
      "00": "0:00 h",
      "01": "1:00 h",
      "02": "2:00 h",
      "03": "3:00 h",
      "04": "4:00 h",
      "05": "5:00 h",
      "06": "6:00 h",
      "07": "7:00 h",
      "08": "8:00 h",
      "09": "9:00 h",
      "10": "10:00 h",
      "11": "11:00 h",
      "12": "12:00 h",
      "13": "13:00 h",
      "14": "14:00 h",
      "15": "15:00 h",
      "16": "16:00 h",
      "17": "17:00 h",
      "18": "18:00 h",
      "19": "19:00 h",
      "20": "20:00 h",
      "21": "21:00 h",
      "22": "22:00 h",
      "23": "23:00 h"
    },
    "transferStatus": {
      "pending": "Pendiente",
      "processed": "Procesado",
      "canceled": "Cancelado",
      "cancelled": "Cancelado",
      "completed": "Completado",
      "rejected": "Rechazado",
      "failed": "Error",
      "payment_pending": "Pago pendiente"
    }
    }
